import { translate } from "app/filters/i18nFilter";

// The catalog interpolates `%param%` (`single-spa/localization/custom-interpolation.ts`), so a
// fallback has to carry the same placeholders as the entry it stands in for — otherwise a
// missing entry shows users the raw placeholder.
const interpolate = (text: string, params: Record<string, unknown>): string =>
    text.replace(/%(\w+)%/g, (placeholder, name: string) => (name in params ? String(params[name]) : placeholder));

export const translateWithFallback = (key: string, fallback: string, params?: Record<string, unknown>): string => {
    const value = translate(key, params);

    // i18next hands back the key itself when a key is missing, so the usual
    // `translate(key) || fallback` never reaches the fallback. It hands back the *lowercased*
    // key, though, because every lookup is normalized to match the catalog — so comparing
    // case-sensitively is what would let a camelCase key render on screen as a raw key.
    if (value && value.toLowerCase() !== key.toLowerCase()) {
        return value;
    }

    return params ? interpolate(fallback, params) : fallback;
};
